module.exports = __webpack_public_path__ + "js.XZFw-CrE.svg";